import React, { useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { FaCheckCircle, FaWhatsapp, FaPhone } from "react-icons/fa";
import LeadForm from "../components/LeadForm";
import Footer from "../Home/Footer";
import "./GetStarted.css";

const BENEFITS = [
  "Basic website from ₹2,500 — Advanced up to ₹50,000+",
  "Single-page to enterprise multi-page websites",
  "WhatsApp click-to-chat & Google Maps included",
  "Admin portal for content & lead management (Premium+)",
  "Mobile responsive — works on all devices",
  "259+ business categories supported",
];

const GetStarted = () => {
  const [params] = useSearchParams();
  const packageName = params.get("package") || "";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="get-started-hero">
        <div className="get-started-inner">
          <div className="get-started-left">
            <span className="get-started-badge">🚀 Trusted by 500+ Local Businesses</span>
            <h1>
              {packageName
                ? `Get Started with ${packageName}`
                : "Get Your Business Online — Starting at ₹2,500"}
            </h1>
            <p className="get-started-desc">
              Stop losing customers to competitors online. AI4Bazaar builds beautiful, sales-ready websites for shops, salons, clinics, and more — fast and affordable.
            </p>
            <ul className="get-started-benefits">
              {BENEFITS.map((b) => (
                <li key={b}><FaCheckCircle /> {b}</li>
              ))}
            </ul>
            <div className="get-started-quick">
              <a href="https://wa.me/919392014678?text=Hi!%20I%20want%20to%20get%20started%20with%20AI4Bazaar" className="get-started-wa" target="_blank" rel="noopener noreferrer">
                <FaWhatsapp /> Chat on WhatsApp
              </a>
              <a href="tel:+919392014678" className="get-started-call">
                <FaPhone /> +91 9392014678
              </a>
            </div>
          </div>
          <div className="get-started-right">
            <LeadForm packageName={packageName} source="get-started-page" />
          </div>
        </div>
      </section>

      <section className="get-started-social-proof">
        <p>Businesses we help go online every day:</p>
        <div className="get-started-tags">
          {["Tea Stalls", "Salons", "Pharmacies", "Bakeries", "Clinics", "General Stores", "Food Vendors"].map((t) => (
            <span key={t}>{t}</span>
          ))}
        </div>
      </section>

      <section className="get-started-pricing-cta">
        <h2>Not sure which package?</h2>
        <p>View our pricing plans or <Link to="/contact">contact us</Link> for a custom quote.</p>
        <Link to="/pricing" className="get-started-pricing-btn" onClick={() => window.scrollTo(0, 0)}>View Pricing Plans</Link>
      </section>

      <Footer />
    </>
  );
};

export default GetStarted;
